import { OnInit, EventEmitter } from '@angular/core';
import { UtilService } from '../utils';
var FileUploadComponent = /** @class */ (function () {
    function FileUploadComponent(utils) {
        this.utils = utils;
        this.eventFilesUpload = new EventEmitter();
        this.filesToUpload = new Array();
    }
    FileUploadComponent.prototype.ngOnInit = function () {
    };
    FileUploadComponent.prototype.handleFileInput = function (event) {
        this.utils.validateFileToUpload(event, this.filesToUpload, this.eventFilesUpload);
    };
    return FileUploadComponent;
}());
export { FileUploadComponent };
